var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMdiTimerSandComplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:timer-sand-complete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 14.6673H4V10.6673L6.66667 8.00065L4 5.33398V1.33398H12V5.33398L9.33333 8.00065L12 10.6673M5.33333 5.00065L8 7.66732L10.6667 5.00065V2.66732H5.33333M8 8.33398L5.33333 11.0007V13.334H10.6667V11.0007M9.33333 12.0007H6.66667V11.4673L8 10.134L9.33333 11.4673V12.0007Z",
    fill: "#3D40D5"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiTimerSandComplete);
export default __webpack_public_path__ + "static/media/mdi_timer-sand-complete.2d2754cf892129f431aa31a4b94a01dd.svg";
export { ForwardRef as ReactComponent };